var ThrottleScheduler = /** @class */ (function () {
    function ThrottleScheduler() {
        this._lastTask = null;
    }
    ThrottleScheduler.prototype.schedule = function (task) {
        var _this = this;
        if (!this._timeoutID) {
            this._timeoutID = window.setTimeout(function () {
                var _a;
                _this._timeoutID = undefined;
                (_a = _this._lastTask) === null || _a === void 0 ? void 0 : _a.call(_this);
            });
        }
        this._lastTask = task;
    };
    ThrottleScheduler.prototype.clear = function () {
        window.clearTimeout(this._timeoutID);
        this._lastTask = null;
        this._timeoutID = undefined;
    };
    return ThrottleScheduler;
}());
export { ThrottleScheduler };
